(() => {
    class Storage {
        /**
         * @param name unique name/identifier of the instance
         * @param parent Object makes reachable entire storage-data over the `data` value (reserved)
         */
        constructor(name, parent = null) {
            this.active     = true;
            this.timelimit  = App.Variable('storageTimestamp') || -1;
            this.validation = {
                session:    true,
                timestamp:  true,
            };
            this
                .setName(name)
                .setDriver((this.timelimit === -1) ? sessionStorage : localStorage)
                .connection()
            ;
            this.data = this.get();

            if (parent) {
                parent.Storage = this;
                Object.defineProperty(parent, 'data', {
                    get:            ()     => this.get(),
                    set:            data   => this.set(data),
                    configurable:   true
                });
            }
        }

        /**
         * Checks for Compatibility and turn off if not compatible
         *
         * @return
         */
        connection() {
            // do not try to connect if storage is false
            if (!this.active) return this;
            try {
                this.driver.getItem(this.getName());
            } catch (e) {
                // if storage is not available
                this.active = false;
                return;
            }
            return this;
        }

        /**
         * Get data from Storage
         *
         * @return Data
         */
        get(key = false) {
            if (this.active) {
                let storage = this.storage || JSON.parse(this.driver.getItem(this.getName()));
                if (storage !== null) {
                    this.storage = storage;
                    // Do not return storage if it is not valid
                    if (!this.isValid(storage))
                        return;
                    if (key) {
                        return storage['data'][key];
                    } else {
                        return storage['data'];
                    }
                }
            } else {
                return key ? this.data[key] : this.data || {};
            }
        }

        /**
         * De/activate a validation param
         *
         * @param name String
         * @param value Boolean
         *
         * @return this
         */
        setValidation(name, value) {
            this.validation[name] = value;
            return this;
        }

        isValid(storage) {
            // Do not return storage if it has expired
            if (this.validation.timestamp && storage['timestamp'] < this.timelimit)
                return false;
            // Do not return storage if belongs to another session
            if (this.validation.session && storage['session'] !== App.sessionId)
                return false;
            return true;
        }

        /**
         * Set data into Storage
         *
         * @keydata key or data to set, key in case you want to set a part of data
         * @data Optional, only if you are setting a part of the data (keydata)
         */
        set(keydata, data = false) {
            if (data) {
                this.data = (this.get()) ? this.get() : {} ;
                this.data[keydata] = data;
            } else {
                this.data = keydata;
            }
            this.save();
            return this;
        }

        /**
         * Set  instances name
         *
         * @name string
         */
        setName(name) {
            const a = [name];
            if (App.language) a.push(App.language);
            this.name = a.join('-').toLowerCase();
            return this;
        }

        /**
         * Get instances name
         */
        getName() {
            return this.name;
        }

        /**
         * Swap driver to work with
         *
         * @driver Instances driver to work with
         */
        setDriver(driver = sessionStorage) {
            this.driver = driver;
            return this;
        }

        /**
         * Save changes into driver
         */
        save() {
            if (!this.active) return this;
            let storage = {
                timestamp:  Math.round(new Date().getTime() / 1000),
                session:    App.sessionId,
                data:       this.data,
            };
            this.storage = storage;
            try {
                this.driver.setItem(this.getName(), JSON.stringify(storage));
            } catch (e) {
                // this means the storage is not responding we need to clear and shut if off until next reload
                App.Interface.Storage.removeAll();
                this.active = false;
            }
            return this;
        }

        /**
         * Remove instances storage
         */
        remove() {
            this.driver.removeItem(this.getName());
            return this;
        }

        /**
         * STATIC
         * Remove all Cache instances !Warning
         */
        static removeAll() {
            sessionStorage.clear();
            localStorage.clear();
        }
    }
    App.Interface.Storage = Storage;
})();
